export const folderSourceAuthorityKeys = {
  all: ['folder-source-authorities'] as const,
  overview: (folderId: string | undefined) =>
    [...folderSourceAuthorityKeys.all, folderId ?? ''] as const,
};
